import { render, staticRenderFns } from "./DashboardEmpty.vue?vue&type=template&id=9b2511cc&scoped=true&"
import script from "./DashboardEmpty.vue?vue&type=script&lang=js&"
export * from "./DashboardEmpty.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b2511cc",
  null
  
)

export default component.exports